import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const FRAUD_TYPES = [
  {
    title: "Forex Betrug",
    subtitle: "Unregulierte Broker, manipulierte Handelsplattformen, gefälschte Gewinne, Auszahlungsblockaden.",
    image: "https://images.pexels.com/photos/12955791/pexels-photo-12955791.jpeg?cs=srgb&dl=pexels-freestockpro-12955791.jpg&fm=jpg",
    points: ["Unregulierte Broker", "Manipulierte Plattformen", "Gefälschte Gewinne", "Auszahlungsblockaden"],
  },
  {
    title: "Trading Betrug",
    subtitle: "CFD Betrug, binäre Optionen Scams, automatische Trading Bots, Copy Trading Betrug.",
    image: "https://images.pexels.com/photos/534216/pexels-photo-534216.jpeg?cs=srgb&dl=pexels-pixabay-534216.jpg&fm=jpg",
    points: ["CFD Betrug", "Binäre Optionen Scams", "Trading Bots", "Copy Trading Betrug"],
  },
  {
    title: "Krypto Betrug",
    subtitle: "Fake ICOs, Romance Scams mit Krypto, Pig Butchering Scams, gefälschte Krypto Börsen.",
    image: "https://images.pexels.com/photos/4808279/pexels-photo-4808279.jpeg?cs=srgb&dl=pexels-ewankennedy-4808279.jpg&fm=jpg",
    points: ["Fake ICOs", "Romance Scams", "Pig Butchering", "Gefälschte Krypto Börsen"],
  },
  {
    title: "Festgeld Betrug",
    subtitle: "Gefälschte Bankwebseiten, nicht existierende Banken, Identitätsdiebstahl, Festgeld Vermittler Scams.",
    image: "https://images.pexels.com/photos/19920920/pexels-photo-19920920.jpeg?cs=srgb&dl=pexels-mibernaa-19920920.jpg&fm=jpg",
    points: ["Gefälschte Bankwebseiten", "Nicht existierende Banken", "Identitätsdiebstahl", "Vermittler-Scams"],
  },
  {
    title: "Bank Betrug",
    subtitle: "Phishing Angriffe, gefälschte Bankmitarbeiter, SWIFT Betrug, unberechtigte Überweisungen.",
    image: "https://images.pexels.com/photos/5497951/pexels-photo-5497951.jpeg?cs=srgb&dl=pexels-eduschadesoares-5497951.jpg&fm=jpg",
    points: ["Phishing Angriffe", "Gefälschte Bankmitarbeiter", "SWIFT Betrug", "Unberechtigte Überweisungen"],
  },
];

export function FraudTypes() {
  const [idx, setIdx] = useState(0);
  const active = FRAUD_TYPES[idx];
  const next = () => setIdx((value) => (value + 1) % FRAUD_TYPES.length);
  const prev = () => setIdx((value) => (value - 1 + FRAUD_TYPES.length) % FRAUD_TYPES.length);

  return (
    <section id="leistungen" className="scroll-mt-24 bg-background py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl">Unsere Spezialisierungen</h2>
          <p className="mt-3 text-muted-foreground">
          Mit über 10 Jahren Erfahrung haben wir uns auf verschiedene Betrugsarten spezialisiert. Sie zahlen nur bei Erfolg.


          </p>
        </div>

        <div className="mt-12 overflow-hidden rounded-2xl bg-card shadow-[var(--shadow-elegant)]">
          <div className="grid md:grid-cols-2">
            <div className="flex flex-col justify-center bg-navy p-8 text-primary-foreground md:order-1 md:p-12">
              <p className="text-xs font-semibold uppercase tracking-widest text-gold">
                Typische Betrugsfälle
              </p>
              <h3 className="mt-3 text-2xl font-bold md:text-3xl">{active.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-white/80 md:text-base">{active.subtitle}</p>

              <ul className="mt-6 grid gap-3 text-sm text-white/85 md:text-base">
                {active.points.map((point) => (
                  <li key={point} className="flex items-center gap-3">
                    <span className="h-2 w-2 rounded-full bg-gold" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 flex items-center gap-3">
                <button
                  type="button"
                  onClick={prev}
                  aria-label="Vorherige Betrugsart"
                  className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-white/5 text-primary-foreground transition-colors hover:border-gold hover:text-gold"
                >
                  <ChevronLeft className="h-5 w-5" />
                </button>
                <button
                  type="button"
                  onClick={next}
                  aria-label="Nächste Betrugsart"
                  className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-white/5 text-primary-foreground transition-colors hover:border-gold hover:text-gold"
                >
                  <ChevronRight className="h-5 w-5" />
                </button>

                <div className="ml-2 flex gap-2">
                  {FRAUD_TYPES.map((item, index) => (
                    <button
                      key={item.title}
                      type="button"
                      onClick={() => setIdx(index)}
                      aria-label={item.title}
                      className={`h-2.5 rounded-full transition-all ${
                        index === idx ? "w-8 bg-gold" : "w-2.5 bg-white/30 hover:bg-white/50"
                      }`}
                    />
                  ))}
                </div>
              </div>
            </div>

            <div className="relative order-2 aspect-[4/5] min-h-[320px] md:aspect-auto md:min-h-[480px]">
              <img
                src={active.image}
                alt={active.title}
                className="absolute inset-0 h-full w-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}